import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const Donate = () => {
    useEffect(() => {
        document.body.style.backgroundImage = 'url("/images/toriiGate.jpg")'; 
        document.body.style.backgroundSize = 'cover';
        document.body.style.backgroundPosition = 'center';
        return () => {
            document.body.style.backgroundImage = 'none';
        };
    }, []);

    return (
        <div className="max-w-4xl mx-auto px-6 py-10 bg-white/80 rounded shadow text-gray-900">
            <h1 className="text-3xl font-bold mb-6 text-center">Donations to the Buddha Wisdom Organization</h1>
            <p className="mb-4">
                Thank you for visiting our donation page. Your generous contribution will help us purchase 40–100 acres (up to 50 hectares) of land to establish our new temple, creating a sanctuary of peace, learning, and refuge for all. With your support, we will be able to build the meditation halls, offer community workshops, and extend a helping hand to those in need—ensuring that compassion and kindness guide every step of our journey.
            </p>
            <p className="mb-4">
                All assets of Buddha Wisdom will ultimately be entrusted to the <a href="https://fpmt.org" className="text-blue-600 hover:underline" target="_blank" rel="noreferrer">FPMT</a> upon the passing of our students Logan Schmidt and Brandon Williams.
            </p>

            <hr className="my-6 border-gray-300" />

            <h2 className="text-xl font-semibold mb-4">Donation Methods</h2>
            <div className="mb-4">
                <p className="mb-2">
                    <strong>US Dollars:</strong> We accept donations via PayPal.
                </p>
                <p className="mb-2">
                    <strong>PayPal:</strong> Donate through PayPal using our designated donation email (TBD).
                </p>
                <p className="mb-4">
                    <strong>Mail a Check:</strong> Please send checks to our PO Box (TBD). We encourage checks over cash for security and assurance.
                </p>
            </div>

            <div className="mb-4">
                <h3 className="text-lg font-medium mb-2">A Note on Mailing Cash</h3>
                <p>
                    While we appreciate every form of generosity, we kindly ask that you avoid mailing cash. This ensures your contribution reaches us safely and reduces the risk of loss in transit.
                </p>
            </div>

            <div className="mb-4">
                <h3 className="text-lg font-medium mb-2">Digital Currencies</h3>
                <p>
                    We gratefully accept cryptocurrency donations. Please send an email to info@buddhawisdom.org to receive our current wallet addresses and for any assistance you may need in making your contribution.
                </p>
            </div>
        </div>
    );
};

export default Donate;
